import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiShield } from 'react-icons/fi';

export default function Hero() {
  return (
    <section className="relative overflow-hidden pb-24 pt-20 sm:pt-28">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-[-10%] h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-brand-400/20 blur-3xl" />
        <div className="absolute right-[8%] top-[30%] h-64 w-64 rounded-full bg-accent-400/20 blur-3xl" />
      </div>

      <div className="container-page grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="flex flex-col items-start gap-6"
        >
          <span className="section-eyebrow">
            <FiShield /> Privacy-first AI
          </span>
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-ink dark:text-white sm:text-5xl lg:text-6xl">
            The AI assistant that keeps{' '}
            <span className="bg-brand-gradient bg-clip-text text-transparent">your business, your business.</span>
          </h1>
          <p className="max-w-xl text-lg leading-relaxed text-muted dark:text-subtle">
            Piua AI gives professionals and organizations the productivity of modern AI without handing over the
            details of who they are, who they work with, or what they're working on. Every message is automatically
            screened for sensitive information before it ever reaches the underlying AI model.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to="/signup" className="btn-primary">
              Get started <FiArrowRight />
            </Link>
            <a href="#privacy" className="btn-secondary">
              See how the privacy layer works
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }}
          className="relative mx-auto w-full max-w-md"
        >
          <div className="card relative animate-floatSlow overflow-hidden p-6">
            <div className="mb-4 flex items-center gap-2 border-b border-line pb-4 dark:border-midnight-600">
              <span className="h-2.5 w-2.5 rounded-full bg-danger/70" />
              <span className="h-2.5 w-2.5 rounded-full bg-warn/70" />
              <span className="h-2.5 w-2.5 rounded-full bg-success/70" />
              <span className="ml-2 text-xs font-medium text-subtle">Piua AI &middot; chat</span>
            </div>

            <div className="flex flex-col gap-4">
              <div className="ml-auto max-w-[85%] rounded-2xl rounded-tr-sm bg-brand-gradient px-4 py-3 text-sm text-white shadow-card">
                Draft a follow-up to{' '}
                <span className="rounded bg-white/25 px-1 line-through decoration-2">Jane Muthoni</span>{' '}
                <span className="rounded bg-white/25 px-1 font-semibold">[Contact A]</span> about the{' '}
                <span className="rounded bg-white/25 px-1 line-through decoration-2">Acme Logistics</span>{' '}
                <span className="rounded bg-white/25 px-1 font-semibold">[Company A]</span> contract renewal.
              </div>

              <div className="flex items-center gap-2 self-end">
                <span className="rounded-full bg-accent-50 px-3 py-1 text-[11px] font-semibold text-accent-700 dark:bg-accent-900/30 dark:text-accent-300">
                  Filtered for privacy
                </span>
              </div>

              <div className="max-w-[85%] rounded-2xl rounded-tl-sm border border-line bg-surface px-4 py-3 text-sm text-ink dark:border-midnight-600 dark:bg-midnight-700 dark:text-white">
                Here's a draft follow-up you can send to [Contact A] regarding the [Company A] renewal — want me to
                adjust the tone?
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
